const n = Object.freeze({
  ACH: "Translations",
  EN: "English",
  AR: "العربية",
  BN: "বাংলা",
  DE: "Deutsch",
  ES: "Español",
  FR: "Français",
  ID: "Indonesian",
  IT: "Italiano",
  SW: "Kiswahili",
  KO: "한국어",
  MN: "Монгол",
  PL: "Polish",
  PT: "Português",
  RU: "Русский",
  SI: "සිංහල",
  TH: "ไทย",
  TR: "Türkçe",
  VI: "Tiếng Việt",
  ZH_CN: "简体中文",
  ZH_TW: "繁體中文"
}), s = "i18n_language", e = "EN", t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ALL_LANGUAGES: n,
  DEFAULT_LANGUAGE: e,
  LANGUAGE_KEY: s
}, Symbol.toStringTag, { value: "Module" }));
export {
  n as A,
  e as D,
  s as L,
  t as c
};
